import { openJoinInvite } from '../core/navigation/joinInviteController';
import type { RemotePushMessage } from './pushNotificationTypes';

function readDataString(
  data: Record<string, unknown> | undefined,
  key: string,
): string | null {
  if (!data) return null;
  const direct = data[key];
  if (typeof direct === 'string' && direct.trim()) return direct.trim();
  const nested = data.data;
  if (nested && typeof nested === 'object') {
    const inner = (nested as Record<string, unknown>)[key];
    if (typeof inner === 'string' && inner.trim()) return inner.trim();
  }
  return null;
}

export function inviteTokenFromPush(message: RemotePushMessage): string | null {
  const data = message.data;
  const type = readDataString(data, 'type');
  const event = readDataString(data, 'event');
  const token = readDataString(data, 'token');
  if (!token) return null;
  if (type === 'household_invite' || event === 'invite_received') return token;
  return token;
}

/** Push tap / foreground banner → join household when this is an invite. */
export function handleNotificationTap(message: RemotePushMessage): boolean {
  const token = inviteTokenFromPush(message);
  if (!token) return false;
  return openJoinInvite(token);
}
